module.exports = __webpack_public_path__ + "img/title3.d1831e64.png";